module.exports = __webpack_public_path__ + "img/1.bbf12fef.jpg";